import EdelweissReaderLink from '../ReviewCopy/EdelweissReaderLink';
import { useWebReaderGalleyAccess } from '../hooks/useWebReaderGalleyAccess';
import DrcActionDownloadOption from './DrcActionDownloadOption';
import DrcActionRequestOption from './DrcActionRequestOption';

export const TitleActionsScroller = ({
	title,
	tooltipPlacement,
	doAllowOpenReviewCopyActionOnMount,
}) => {
	const { sku } = title;
	const { hasWebReaderGalleyAccess } = useWebReaderGalleyAccess();

	return (
		<div className="list-action-frame" style={{ marginRight: '10px' }}>
			{hasWebReaderGalleyAccess(sku) && (
				<div
					className="column-right"
					style={{ marginBottom: '5px', marginTop: '5px' }}>
					<EdelweissReaderLink title={title} buttonType="round" />
				</div>
			)}
			{(title.isDownloadable || title.isRequestable) && (
				<div style={{ marginTop: '5px' }}>
					{title.isDownloadable ? (
						<DrcActionDownloadOption
							title={title}
							tooltipPlacement={tooltipPlacement}
							doAllowOpenReviewCopyActionOnMount={
								doAllowOpenReviewCopyActionOnMount
							}
						/>
					) : (
						<DrcActionRequestOption
							title={title}
							tooltipPlacement={tooltipPlacement}
							doAllowOpenReviewCopyActionOnMount={
								doAllowOpenReviewCopyActionOnMount
							}
						/>
					)}
				</div>
			)}
			<div className="clear" />
		</div>
	);
};

TitleActionsScroller.defaultProps = {
	doAllowOpenReviewCopyActionOnMount: false,
};

export default TitleActionsScroller;
